<template>
  <footer
    class="p-6 text-center text-gray-400 bg-gray-800 dark:bg-gray-900 dark:text-gray-300 transition-colors duration-200"
  >
    <div class="pt-8 mt-8">
      <p>
        &copy; {{ new Date().getFullYear() }}
        <a href="https://kappaml.com" class="hover:underline">KappaML</a>. Built
        with 🩵 in Enschede, The Netherlands.
      </p>
    </div>
  </footer>
</template>
